export default function uniqueFunctionNameDirective(
  $q,
  emSharedModelService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const processId = attributes.processId || 0;
    const functionId = attributes.functionId || 0;
    let initialValue = null;
    ngModel.$asyncValidators.emFunctionUniqueName = (modelValue) => {
      if (!initialValue) { initialValue = modelValue; }
      if (initialValue === modelValue) return $q.resolve();
      return emSharedModelService.checkFunctionNameExists(
        processId, functionId, modelValue
      )
        .then((nameExists) => {
          if (!nameExists) {
            return $q.resolve();
          }
          return $q.reject();
        })
        .catch(() => $q.reject());
    };
  }
}

export const name = 'emFunctionUniqueName';

uniqueFunctionNameDirective.$inject = [
  '$q',
  'emSharedModelService',
];
